<div class="container-fluid p-4 overflow-auto" [style]="(`height: calc(100vh - 150px)`)">
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center">
                <h4 class="mb-0 text-secondary">{{ title }}</h4>
                <div class="d-flex align-items-center mt-3 mt-md-0">
                    <dx-select-box
                        class="me-3"
                        [label]="'&nbsp;'"
                        [items]="aggregateOptions"
                        [(value)]="aggregateValue"
                        (onValueChanged)="onAggregateChanged()"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled">
                    </dx-select-box>
                    <dx-date-range-box
                        [multiView]="false"
                        [showClearButton]="true"
                        [(value)]="dateRangeFilterValue"
                        (onValueChanged)="onDateRangeChanged($event)"
                        stylingMode="filled">
                    </dx-date-range-box>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-4">
        <div class="col-12">
            <app-blocked-stock-chart
                title="Blocked Stock"
                [data]="data"
                [series]="blockedStockSeries"
                [formatPercent]="false"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-chart
                title="% of Block Stock"
                [data]="data"
                [series]="blockedStockPercentSeries"
                [targetValue]="0.02"
                targetLabel="Target 2%"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-chart
                title="No RAC Coding"
                [data]="data"
                [series]="noRacCodingSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-doughnut-chart
                title="Days On Hold"
                [data]="data"
                [segments]="daysOnHoldSegments"
                centerMode="largest">
            </app-blocked-stock-doughnut-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-doughnut-chart
                title="Reason"
                [data]="data"
                [segments]="reasonSegments"
                centerMode="total"
                totalField="totalBlockedStock"
                centerLabel="Blocked">
            </app-blocked-stock-doughnut-chart>
        </div>

        <div class="col-12 col-lg-4">
            <app-blocked-stock-chart
                title="30 Days on Hold"
                [data]="data"
                [series]="onHold30DaysSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-4">
            <app-blocked-stock-chart
                title="45 Days on Hold"
                [data]="data"
                [series]="onHold45DaysSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-4">
            <app-blocked-stock-chart
                title="90 Days on Hold"
                [data]="data"
                [series]="onHold90DaysSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-chart
                title="Expired or Nearing Expiry"
                [data]="data"
                [series]="expirySeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-chart
                title="Quality Issue"
                [data]="data"
                [series]="qualityIssueSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-4">
            <app-blocked-stock-chart
                title="Returns"
                [data]="data"
                [series]="returnsSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-4">
            <app-blocked-stock-chart
                title="Damage"
                [data]="data"
                [series]="damageSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-4">
            <app-blocked-stock-chart
                title="Logistical"
                [data]="data"
                [series]="logisticalSeries"
                [aggregateType]="aggregateValue"
                [wholeRange]="wholeRange"
                [visualRange]="visualRange">
            </app-blocked-stock-chart>
        </div>
    </div>
</div>
